export default "__VITE_ASSET__PCTfbB81__"